export default "__VITE_ASSET__Bl60XUm8__"